var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-profile"},[_c('h1',{staticClass:"subtitle-1 grey--text"},[_vm._v("Documentation")]),_c('p',[_vm._v("Coming soon...")])])}]

export { render, staticRenderFns }